// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { domainStatusGuard, domainDnsRecordsGuard, domainVerificationFilesGuard, cloudflareDataGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    domain: z.string().min(1).max(256),
    status: domainStatusGuard.optional(),
    errorMessage: z.string().max(1024).nullable().optional(),
    dnsRecords: domainDnsRecordsGuard.optional(),
    verificationFiles: domainVerificationFilesGuard.optional(),
    cloudflareData: cloudflareDataGuard.nullable().optional(),
    updatedAt: z.number().optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    domain: z.string().min(1).max(256),
    status: domainStatusGuard,
    errorMessage: z.string().max(1024).nullable(),
    dnsRecords: domainDnsRecordsGuard,
    verificationFiles: domainVerificationFilesGuard,
    cloudflareData: cloudflareDataGuard.nullable(),
    updatedAt: z.number(),
    createdAt: z.number(),
});
export const Domains = Object.freeze({
    table: 'domains',
    tableSingular: 'domain',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        domain: 'domain',
        status: 'status',
        errorMessage: 'error_message',
        dnsRecords: 'dns_records',
        verificationFiles: 'verification_files',
        cloudflareData: 'cloudflare_data',
        updatedAt: 'updated_at',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'domain',
        'status',
        'errorMessage',
        'dnsRecords',
        'verificationFiles',
        'cloudflareData',
        'updatedAt',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
